import moment from "moment";

export const initFilesSearchFormState = {
  PageNumber: 1,
  Size: 20,
  FileNames: "",
  CustomerId: null,
  ProjectId: null,
  StatusFilter: "",
  SlaFilter: ["ok", "breached", "breachwarning", "calcfailed"],
  Run: "",

  CustomerLegacyId: null,
  flowid: null,

  ErrorFilter: false,
  ExpFilter: false,
  hasbbs: false,
  ChannelName: null,
  Start: null,
  End: null,

  moreArrowIcon: "fa-chevron-down",
  toggleBtnTitle: "Show advanced search options",
  showMoreHeight: 0,
};

export const initDocsSearchFormState = {
  PageNumber: 1,
  Size: 20,
  DocumentNumbers: "",
  CustomerId: null,
  ProjectId: null,
  DocStatus: "",

  DocId: "",
  batch: "",
  Run: "",
  Sender: "",
  Receiver: "",
  BySenderId: true,
  ByReceiverId: true,
  hasbbs: false,

  Tags: null,
  NTags: null,
  TctIn: true,

  Start: null,
  End: null,

  moreArrowIcon: "fa-chevron-down",
  toggleBtnTitle: "Show advanced search options",
  showMoreHeight: 0,
};
export const initExecReportsSearchFormState = {
  PageNumber: 1,
  Size: 20,
  SearchText: "",
  CustomerId: null,
  ProjectId: null,
  ReportState: "",
  HasDocuments: false,

  TemplateId: "",
  Start: null,
  End: null,

  moreArrowIcon: "fa-chevron-down",
  toggleBtnTitle: "Show advanced search options",
  showMoreHeight: 0,
};
export const initConfigReportsSearchFormState = {
  PageNumber: 1,
  Size: 20,
  Reportname: "",
  CustomerId: null,
  ProjectId: null,

  CustomerLegacyId: null,
  ChannelName: null,
  Start: null,
  End: null,
  IncludeInactive: false,
  PipelineDefinitionId: "",

  moreArrowIcon: "fa-chevron-down",
  toggleBtnTitle: "Show advanced search options",
  showMoreHeight: 0,
};

var _from = moment
  .utc()
  .subtract(1, "month")
  .add(1, "day")
  .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  .toDate();
var _to = moment
  .utc()
  .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
  .toDate();

export const initDashboardSearchFormState = {
  Start: _from,
  End: _to,
  CustomerId: null,
  ProjectId: null,
  moreArrowIcon: "fa-chevron-down",
  toggleBtnTitle: "Show advanced search options",
  showMoreHeight: 0,
};

export const initHomeSearchFormState = {
  PageNumber: 1,
  Size: 2,
  SearchText: "",
  CustomerId: null,
};

export const internalSteps = [
  {
    intro: "Welcome to Track & Trace",
  },
  {
    element: ".dashTab",
    intro:
      "Here you can see charts showing different <strong>consolidated data</strong> - channel deliveries, top companies, SLA stats, etc.",
  },
  {
    element: ".filesTab",
    intro:
      "You can <strong>search files</strong> in this tab. If file line is clicked then in expanded panel you will find more details about file - channel details etc.",
  },
  {
    element: ".docsTab",
    intro:
      "Search for documents. If document line is clicked then you will find more details about document - channel details etc",
  },
  {
    element: ".reportsTab",
    intro:
      "In this tab you can search <strong>executed reports</strong> - check generated files, restart report<br/>It also allows to <strong>add/edit reports</strong> and change report configuration",
  },
  {
    element: ".configTab",
    intro:
      "Configure T&T -  Add/edit customers - configure basic data, legacy IDs, projects, reports",
  },
  {
    element: ".smart-search-btn",
    intro: "Quick search feature.",
  },
  {
    element: ".w_user_console.w_user_2",
    intro:
      "You can <strong>switch to external user</strong> by pressing this button. Choose a user in list and you will see the view as user sees it - customer views show less data and channel data is grouped. <strong>Be aware</strong>, that when you switch to particular customer's user, you act as him. So if you, for example, change time zone, it will be saved as if it was done by customer. Pressing button again will return you back to internal views",
  },
  {
    element: ".add-issue-btn",
    intro:
      "<strong>Report issue</strong> Press this button and fill form to submit issue/question to T&T development team",
  },
  {
    element: ".tooltip-btn",
    intro:
      "<strong>Detailed help</strong> on T&T functionality - Button is context sensitive, so if you will press button in Documents view, then you will be navigated to appropriate paragraph",
  },
  {
    element: ".w_user_settings_icon",
    intro: "Change user settings here",
  },
  {
    element: ".logoutTab",
    intro: "Logs you out of T&T Portal",
  },
  {
    element: "button.btn-posti-default",
    intro: "Hit this button to start querying data",
  },
  {
    element: ".search-top-advanced-calc",
    intro: "Press this button to see more querying options",
  },
];

export const externalSteps = [
  {
    element: ".nav-link.default-top-bar-color",
    intro:
      "<strong>Home page</strong> - you can do search for files and documents from this view. Press buttons in search results to view more details about document or file. View also shows brief statistics about recently processed files and documents.",
  },
  {
    element: ".filesTab",
    intro:
      "You can <strong>search files</strong> in this tab. If file line is clicked then in expanded panel you will find more details about file - channel details etc.",
  },
  {
    element: ".docsTab",
    intro:
      "Search for documents. If document line is clicked then you will find more details about document - channel details etc",
  },
  {
    element: ".reportsTab",
    intro: "In this tab you can search for <strong>executed reports</strong>",
  },
  {
    element: ".tooltip-btn",
    intro:
      "<strong>Detailed help</strong> on T&T functionality - Button is context sensitive, so if you will press button in Documents view, then you will be navigated to appropriate paragraph",
  },
  {
    element: ".w_user_settings_icon",
    intro: "Change user settings here",
  },
  {
    element: ".logoutTab",
    intro: "Logs you out of T&T Portal",
  },
  {
    element: "button.btn-posti-default",
    intro: "Hit this button to start querying data",
  },
];

export const senderSteps = [
  {
    intro: "Welcome to Track & Trace",
  },
  {
    element: ".docsTab",
    intro:
      "Search for documents. If document line is clicked then you will find more details about document - channel details etc",
  },
  {
    element: ".tooltip-btn",
    intro:
      "<strong>Detailed help</strong> on T&T functionality - Button is context sensitive, so if you will press button in Documents view, then you will be navigated to appropriate paragraph",
  },
  {
    element: ".w_user_settings_icon",
    intro: "Change user settings here",
  },
  {
    element: ".logoutTab",
    intro: "Logs you out of T&T Portal",
  },
  {
    element: "button.btn-posti-default",
    intro: "Hit this button to start querying data",
  },
  {
    element: ".search-top-advanced-calc",
    intro: "Press this button to see more querying options",
  },
];
